import { TRANSACTIONS_PATH, RETAIL_PATH } from '../root'

const NEW_PATH = 'new'
const NEW_FULL_PATH = `${RETAIL_PATH}${TRANSACTIONS_PATH}/${NEW_PATH}`
const DEBIT_CARD_PATH = ':transaction_id/status'

export { NEW_PATH, NEW_FULL_PATH, DEBIT_CARD_PATH }
